import React, { useState } from 'react';
// import '../styles/ElementorSettings.css';

const ElementorSettings = ({ 
  selectedSection, 
  selectedElement, 
  onUpdateSection, 
  onUpdateWidget,
  pageSettings,
  setPageSettings,
  showSettings,
  setShowSettings 
}) => {
  const [activeTab, setActiveTab] = useState('content');
  
  if (!showSettings) return null;
  
  const renderSectionSettings = () => {
    if (!selectedSection) return null;
    
    return (
      <div className="settings-panel border-start bg-light">
        <div className="settings-header">
          <h3>Section Settings</h3>
          <button className="close-btn" onClick={() => setShowSettings(false)}>×</button>
        </div>
        
        <div className="settings-tabs">
          <button className={`tab ${activeTab === 'content' ? 'active' : ''}`} onClick={() => setActiveTab('content')}>
            Content
          </button>
          <button className={`tab ${activeTab === 'style' ? 'active' : ''}`} onClick={() => setActiveTab('style')}>
            Style
          </button>
          <button className={`tab ${activeTab === 'advanced' ? 'active' : ''}`} onClick={() => setActiveTab('advanced')}>
            Advanced
          </button>
        </div>
        
        <div className="settings-content">
          {activeTab === 'content' && (
            <div className="settings-group">
              <h4>Background</h4>
              <div className="setting-field">
                <label>Background Type</label>
                <select 
                  value={selectedSection.settings.backgroundImage !== null ? 'image' : 'color'}
                  onChange={(e) => {
                    if (e.target.value === 'color') {
                      onUpdateSection(selectedSection.id, {
                        settings: { 
                          ...selectedSection.settings, 
                          backgroundImage: null,
                          backgroundColor: selectedSection.settings.backgroundColor || '#ffffff'
                        }
                      });
                    } else if (e.target.value === 'image') {
                      onUpdateSection(selectedSection.id, {
                        settings: { 
                          ...selectedSection.settings, 
                          backgroundImage: selectedSection.settings.backgroundImage ?? '',
                          backgroundColor: selectedSection.settings.backgroundColor || '#ffffff'
                        }
                      });
                    }
                  }}
                >
                  <option value="color">Color</option>
                  <option value="image">Image</option>
                </select>
              </div>
              
              {selectedSection.settings.backgroundImage === null && (
                <div className="setting-field">
                  <label>Background Color</label>
                  <input 
                    type="color" 
                    value={selectedSection.settings.backgroundColor || '#ffffff'}
                    onChange={(e) => onUpdateSection(selectedSection.id, {
                      settings: { ...selectedSection.settings, backgroundColor: e.target.value }
                    })}
                  />
                </div>
              )}
              
              {selectedSection.settings.backgroundImage !== null && (
                <div className="setting-field">
                  <label>Background Image URL</label>
                  <input 
                    type="text" 
                    value={selectedSection.settings.backgroundImage || ''}
                    placeholder="Enter image URL"
                    onChange={(e) => onUpdateSection(selectedSection.id, {
                      settings: { ...selectedSection.settings, backgroundImage: e.target.value }
                    })}
                  />
                </div>
              )}
            </div>
          )}
          
          {activeTab === 'style' && (
            <>
              <div className="settings-group">
                <h4>Spacing</h4>
                <div className="setting-field">
                  <label>Padding</label>
                  <div className="spacing-controls">
                    <div className="spacing-field">
                      <label>Top</label>
                      <input 
                        type="number" 
                        value={selectedSection.settings.padding.top}
                        onChange={(e) => onUpdateSection(selectedSection.id, {
                          settings: {
                            ...selectedSection.settings,
                            padding: { ...selectedSection.settings.padding, top: parseInt(e.target.value) }
                          }
                        })}
                      />
                    </div>
                    <div className="spacing-field">
                      <label>Right</label>
                      <input 
                        type="number" 
                        value={selectedSection.settings.padding.right}
                        onChange={(e) => onUpdateSection(selectedSection.id, {
                          settings: {
                            ...selectedSection.settings,
                            padding: { ...selectedSection.settings.padding, right: parseInt(e.target.value) }
                          }
                        })}
                      />
                    </div>
                    <div className="spacing-field">
                      <label>Bottom</label>
                      <input 
                        type="number" 
                        value={selectedSection.settings.padding.bottom}
                        onChange={(e) => onUpdateSection(selectedSection.id, {
                          settings: {
                            ...selectedSection.settings,
                            padding: { ...selectedSection.settings.padding, bottom: parseInt(e.target.value) }
                          }
                        })}
                      />
                    </div>
                    <div className="spacing-field">
                      <label>Left</label>
                      <input 
                        type="number" 
                        value={selectedSection.settings.padding.left}
                        onChange={(e) => onUpdateSection(selectedSection.id, {
                          settings: {
                            ...selectedSection.settings,
                            padding: { ...selectedSection.settings.padding, left: parseInt(e.target.value) }
                          }
                        })}
                      />
                    </div>
                  </div>
                </div>
                
                <div className="setting-field">
                  <label>Margin</label>
                  <div className="spacing-controls">
                    <div className="spacing-field">
                      <label>Top</label>
                      <input 
                        type="number" 
                        value={selectedSection.settings.margin?.top || 0}
                        onChange={(e) => onUpdateSection(selectedSection.id, {
                          settings: {
                            ...selectedSection.settings,
                            margin: { 
                              ...selectedSection.settings.margin, 
                              top: parseInt(e.target.value) || 0 
                            }
                          }
                        })}
                      />
                    </div>
                    <div className="spacing-field">
                      <label>Right</label>
                      <input 
                        type="number" 
                        value={selectedSection.settings.margin?.right || 0}
                        onChange={(e) => onUpdateSection(selectedSection.id, {
                          settings: {
                            ...selectedSection.settings,
                            margin: { 
                              ...selectedSection.settings.margin, 
                              right: parseInt(e.target.value) || 0 
                            }
                          }
                        })}
                      />
                    </div>
                    <div className="spacing-field">
                      <label>Bottom</label>
                      <input 
                        type="number" 
                        value={selectedSection.settings.margin?.bottom || 0}
                        onChange={(e) => onUpdateSection(selectedSection.id, {
                          settings: {
                            ...selectedSection.settings,
                            margin: { 
                              ...selectedSection.settings.margin, 
                              bottom: parseInt(e.target.value) || 0 
                            }
                          }
                        })}
                      />
                    </div>
                    <div className="spacing-field">
                      <label>Left</label>
                      <input 
                        type="number" 
                        value={selectedSection.settings.margin?.left || 0}
                        onChange={(e) => onUpdateSection(selectedSection.id, {
                          settings: {
                            ...selectedSection.settings,
                            margin: { 
                              ...selectedSection.settings.margin, 
                              left: parseInt(e.target.value) || 0 
                            }
                          }
                        })}
                      />
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="settings-group">
                <h4>Border</h4>
                <div className="setting-field">
                  <label>Border Radius (px)</label>
                  <input 
                    type="number" 
                    value={selectedSection.settings.borderRadius}
                    onChange={(e) => onUpdateSection(selectedSection.id, {
                      settings: { ...selectedSection.settings, borderRadius: parseInt(e.target.value) }
                    })}
                  />
                </div>
              </div>
            </>
          )}
          
          {activeTab === 'advanced' && (
            <div className="settings-group">
              <h4>Advanced Settings</h4>
              <div className="setting-field">
                <label>CSS Classes</label>
                <input 
                  type="text" 
                  placeholder="Enter custom CSS classes"
                  value={selectedSection.settings.cssClasses || ''}
                  onChange={(e) => onUpdateSection(selectedSection.id, {
                    settings: { ...selectedSection.settings, cssClasses: e.target.value }
                  })}
                />
              </div>
              
              <div className="setting-field">
                <label>CSS ID</label>
                <input 
                  type="text" 
                  placeholder="Enter custom CSS ID"
                  value={selectedSection.settings.cssId || ''}
                  onChange={(e) => onUpdateSection(selectedSection.id, {
                    settings: { ...selectedSection.settings, cssId: e.target.value }
                  })}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };
  
  const renderWidgetSettings = () => {
    if (!selectedElement) return null;
    
    return (
      <div className="settings-panel border-start bg-light">
        <div className="settings-header">
          <h3>{getWidgetName(selectedElement.type)} Settings</h3>
          <button className="close-btn" onClick={() => setShowSettings(false)}>×</button>
        </div>
        
        <div className="settings-tabs">
          <button className={`tab ${activeTab === 'content' ? 'active' : ''}`} onClick={() => setActiveTab('content')}>
            Content
          </button>
          <button className={`tab ${activeTab === 'style' ? 'active' : ''}`} onClick={() => setActiveTab('style')}>
            Style
          </button>
          <button className={`tab ${activeTab === 'advanced' ? 'active' : ''}`} onClick={() => setActiveTab('advanced')}>
            Advanced
          </button>
        </div>
        
        <div className="settings-content">
          {activeTab === 'content' && (
            <>
              {selectedElement.type === 'heading' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Heading Text</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.text}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, text: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Heading Tag</label>
                    <select 
                      value={selectedElement.content.tag}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, tag: e.target.value }
                      })}
                    >
                      <option value="h1">H1</option>
                      <option value="h2">H2</option>
                      <option value="h3">H3</option>
                      <option value="h4">H4</option>
                    </select>
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'paragraph' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Paragraph Text</label>
                    <textarea 
                      rows={4}
                      value={selectedElement.content.text || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, text: e.target.value }
                      })}
                      placeholder="Enter your paragraph text here..."
                    />
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'divider' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Divider Style</label>
                    <select 
                      value={selectedElement.content.style || 'solid'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, style: e.target.value }
                      })}
                    >
                      <option value="solid">Solid</option>
                      <option value="dashed">Dashed</option>
                      <option value="dotted">Dotted</option>
                      <option value="double">Double</option>
                    </select>
                  </div>
                  <div className="setting-field">
                    <label>Divider Weight (px)</label>
                    <input 
                      type="number" 
                      value={selectedElement.content.weight || 1}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, weight: parseInt(e.target.value) }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Divider Color</label>
                    <input 
                      type="color" 
                      value={selectedElement.content.color || '#dddddd'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, color: e.target.value }
                      })}
                    />
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'spacer' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Space Height (px)</label>
                    <input 
                      type="number" 
                      value={selectedElement.content.height || 50}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, height: parseInt(e.target.value) }
                      })}
                    />
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'icon' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Icon Class</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.iconClass || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, iconClass: e.target.value }
                      })}
                      placeholder="e.g., fa fa-home"
                    />
                  </div>
                  <div className="setting-field">
                    <label>Icon Size (px)</label>
                    <input 
                      type="number" 
                      value={selectedElement.content.size || 24}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, size: parseInt(e.target.value) }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Icon Color</label>
                    <input 
                      type="color" 
                      value={selectedElement.content.color || '#000000'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, color: e.target.value }
                      })}
                    />
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'container' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Container Width</label>
                    <select 
                      value={selectedElement.content.width || 'full'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, width: e.target.value }
                      })}
                    >
                      <option value="full">Full Width</option>
                      <option value="boxed">Boxed</option>
                    </select>
                  </div>
                  <div className="setting-field">
                    <label>Content Alignment</label>
                    <select 
                      value={selectedElement.content.align || 'left'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, align: e.target.value }
                      })}
                    >
                      <option value="left">Left</option>
                      <option value="center">Center</option>
                      <option value="right">Right</option>
                    </select>
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'grid' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Grid Columns</label>
                    <select 
                      value={selectedElement.content.columns || 3}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, columns: parseInt(e.target.value) }
                      })}
                    >
                      <option value="1">1 Column</option>
                      <option value="2">2 Columns</option>
                      <option value="3">3 Columns</option>
                      <option value="4">4 Columns</option>
                      <option value="6">6 Columns</option>
                    </select>
                  </div>
                  <div className="setting-field">
                    <label>Gap (px)</label>
                    <input 
                      type="number" 
                      value={selectedElement.content.gap || 20}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, gap: parseInt(e.target.value) }
                      })}
                    />
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'tabs' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Tab Titles (one per line)</label>
                    <textarea 
                      rows={4}
                      value={selectedElement.content.tabs ? selectedElement.content.tabs.map(tab => tab.title).join('\n') : ''}
                      onChange={(e) => {
                        const titles = e.target.value.split('\n').filter(title => title.trim());
                        const tabs = titles.map((title, index) => ({
                          title,
                          content: selectedElement.content.tabs?.[index]?.content || `Content for ${title}`
                        }));
                        onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, tabs }
                        });
                      }}
                      placeholder="Tab 1&#10;Tab 2&#10;Tab 3"
                    />
                  </div>
                  <div className="setting-field">
                    <label>Tab Content (one per line, matching tab titles)</label>
                    <textarea 
                      rows={6}
                      value={selectedElement.content.tabs ? selectedElement.content.tabs.map(tab => tab.content).join('\n') : ''}
                      onChange={(e) => {
                        const contents = e.target.value.split('\n');
                        const tabs = selectedElement.content.tabs?.map((tab, index) => ({
                          ...tab,
                          content: contents[index] || tab.content
                        })) || [];
                        onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, tabs }
                        });
                      }}
                      placeholder="Content for Tab 1&#10;Content for Tab 2&#10;Content for Tab 3"
                    />
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'accordion' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Accordion Items (Title:Content format, one per line)</label>
                    <textarea 
                      rows={6}
                      value={selectedElement.content.items ? selectedElement.content.items.map(item => `${item.title}:${item.content}`).join('\n') : ''}
                      onChange={(e) => {
                        const items = e.target.value.split('\n').filter(line => line.trim()).map(line => {
                          const [title, ...contentParts] = line.split(':');
                          return {
                            title: title?.trim() || '',
                            content: contentParts.join(':').trim() || ''
                          };
                        });
                        onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, items }
                        });
                      }}
                      placeholder="Item 1 Title:Item 1 Content&#10;Item 2 Title:Item 2 Content"
                    />
                  </div>
                  <div className="setting-field">
                    <label>
                      <input 
                        type="checkbox" 
                        checked={selectedElement.content.multiple || false}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, multiple: e.target.checked }
                        })}
                      /> Allow Multiple Open
                    </label>
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'image' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Image URL</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.url}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, url: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Alt Text</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.alt}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, alt: e.target.value }
                      })}
                    />
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'video' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Video URL</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.url || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, url: e.target.value }
                      })}
                      placeholder="YouTube, Vimeo, or direct video URL"
                    />
                  </div>
                  <div className="setting-field">
                    <label>
                      <input 
                        type="checkbox" 
                        checked={selectedElement.content.autoplay || false}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, autoplay: e.target.checked }
                        })}
                      /> Autoplay
                    </label>
                  </div>
                  <div className="setting-field">
                    <label>
                      <input 
                        type="checkbox" 
                        checked={selectedElement.content.controls || true}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, controls: e.target.checked }
                        })}
                      /> Show Controls
                    </label>
                  </div>
                  <div className="setting-field">
                    <label>
                      <input 
                        type="checkbox" 
                        checked={selectedElement.content.muted || false}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, muted: e.target.checked }
                        })}
                      /> Muted
                    </label>
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'audio' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Audio URL</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.url || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, url: e.target.value }
                      })}
                      placeholder="Direct audio file URL"
                    />
                  </div>
                  <div className="setting-field">
                    <label>
                      <input 
                        type="checkbox" 
                        checked={selectedElement.content.autoplay || false}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, autoplay: e.target.checked }
                        })}
                      /> Autoplay
                    </label>
                  </div>
                  <div className="setting-field">
                    <label>
                      <input 
                        type="checkbox" 
                        checked={selectedElement.content.controls || true}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, controls: e.target.checked }
                        })}
                      /> Show Controls
                    </label>
                  </div>
                  <div className="setting-field">
                    <label>
                      <input 
                        type="checkbox" 
                        checked={selectedElement.content.loop || false}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, loop: e.target.checked }
                        })}
                      /> Loop
                    </label>
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'gallery' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Image URLs (one per line)</label>
                    <textarea 
                      rows={6}
                      value={selectedElement.content.images ? selectedElement.content.images.join('\n') : ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, images: e.target.value.split('\n').filter(url => url.trim()) }
                      })}
                      placeholder="https://example.com/image1.jpg&#10;https://example.com/image2.jpg"
                    />
                  </div>
                  <div className="setting-field">
                    <label>Columns</label>
                    <select 
                      value={selectedElement.content.columns || 3}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, columns: parseInt(e.target.value) }
                      })}
                    >
                      <option value="1">1 Column</option>
                      <option value="2">2 Columns</option>
                      <option value="3">3 Columns</option>
                      <option value="4">4 Columns</option>
                    </select>
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'carousel' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Image URLs (one per line)</label>
                    <textarea 
                      rows={6}
                      value={selectedElement.content.images ? selectedElement.content.images.join('\n') : ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, images: e.target.value.split('\n').filter(url => url.trim()) }
                      })}
                      placeholder="https://example.com/image1.jpg&#10;https://example.com/image2.jpg"
                    />
                  </div>
                  <div className="setting-field">
                    <label>
                      <input 
                        type="checkbox" 
                        checked={selectedElement.content.autoplay || false}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, autoplay: e.target.checked }
                        })}
                      /> Autoplay
                    </label>
                  </div>
                  <div className="setting-field">
                    <label>
                      <input 
                        type="checkbox" 
                        checked={selectedElement.content.dots || true}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, dots: e.target.checked }
                        })}
                      /> Show Dots
                    </label>
                  </div>
                  <div className="setting-field">
                    <label>
                      <input 
                        type="checkbox" 
                        checked={selectedElement.content.arrows || true}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, arrows: e.target.checked }
                        })}
                      /> Show Arrows
                    </label>
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'modal' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Modal Title</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.title || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, title: e.target.value }
                      })}
                      placeholder="Modal Title"
                    />
                  </div>
                  <div className="setting-field">
                    <label>Modal Content</label>
                    <textarea 
                      rows={4}
                      value={selectedElement.content.content || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, content: e.target.value }
                      })}
                      placeholder="Modal content here..."
                    />
                  </div>
                  <div className="setting-field">
                    <label>Trigger Button Text</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.buttonText || 'Open Modal'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, buttonText: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Modal Size</label>
                    <select 
                      value={selectedElement.content.size || 'medium'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, size: e.target.value }
                      })}
                    >
                      <option value="small">Small</option>
                      <option value="medium">Medium</option>
                      <option value="large">Large</option>
                      <option value="fullscreen">Fullscreen</option>
                    </select>
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'tooltip' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Tooltip Text</label>
                    <textarea 
                      rows={3}
                      value={selectedElement.content.text || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, text: e.target.value }
                      })}
                      placeholder="Tooltip content"
                    />
                  </div>
                  <div className="setting-field">
                    <label>Trigger Element Text</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.triggerText || 'Hover me'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, triggerText: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Position</label>
                    <select 
                      value={selectedElement.content.position || 'top'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, position: e.target.value }
                      })}
                    >
                      <option value="top">Top</option>
                      <option value="bottom">Bottom</option>
                      <option value="left">Left</option>
                      <option value="right">Right</option>
                    </select>
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'alert' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Alert Message</label>
                    <textarea 
                      rows={3}
                      value={selectedElement.content.message || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, message: e.target.value }
                      })}
                      placeholder="Alert message"
                    />
                  </div>
                  <div className="setting-field">
                    <label>Alert Type</label>
                    <select 
                      value={selectedElement.content.type || 'info'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, type: e.target.value }
                      })}
                    >
                      <option value="info">Info</option>
                      <option value="success">Success</option>
                      <option value="warning">Warning</option>
                      <option value="error">Error</option>
                    </select>
                  </div>
                  <div className="setting-field">
                    <label>
                      <input 
                        type="checkbox" 
                        checked={selectedElement.content.dismissible || true}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, dismissible: e.target.checked }
                        })}
                      /> Dismissible
                    </label>
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'badge' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Badge Text</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.text || 'New'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, text: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Badge Color</label>
                    <input 
                      type="color" 
                      value={selectedElement.content.color || '#007bff'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, color: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Badge Size</label>
                    <select 
                      value={selectedElement.content.size || 'medium'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, size: e.target.value }
                      })}
                    >
                      <option value="small">Small</option>
                      <option value="medium">Medium</option>
                      <option value="large">Large</option>
                    </select>
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'code' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Code Content</label>
                    <textarea 
                      rows={8}
                      value={selectedElement.content.code || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, code: e.target.value }
                      })}
                      placeholder="Enter your code here..."
                    />
                  </div>
                  <div className="setting-field">
                    <label>Language</label>
                    <select 
                      value={selectedElement.content.language || 'javascript'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, language: e.target.value }
                      })}
                    >
                      <option value="javascript">JavaScript</option>
                      <option value="python">Python</option>
                      <option value="html">HTML</option>
                      <option value="css">CSS</option>
                      <option value="json">JSON</option>
                      <option value="sql">SQL</option>
                    </select>
                  </div>
                  <div className="setting-field">
                    <label>
                      <input 
                        type="checkbox" 
                        checked={selectedElement.content.showLineNumbers || false}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, showLineNumbers: e.target.checked }
                        })}
                      /> Show Line Numbers
                    </label>
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'embed' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Embed URL</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.url || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, url: e.target.value }
                      })}
                      placeholder="YouTube, Vimeo, or embed URL"
                    />
                  </div>
                  <div className="setting-field">
                    <label>Embed Type</label>
                    <select 
                      value={selectedElement.content.type || 'video'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, type: e.target.value }
                      })}
                    >
                      <option value="video">Video</option>
                      <option value="iframe">iFrame</option>
                      <option value="custom">Custom HTML</option>
                    </select>
                  </div>
                  <div className="setting-field">
                    <label>Height (px)</label>
                    <input 
                      type="number" 
                      value={selectedElement.content.height || 315}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, height: parseInt(e.target.value) }
                      })}
                    />
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'product' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Product Name</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.name || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, name: e.target.value }
                      })}
                      placeholder="Product Name"
                    />
                  </div>
                  <div className="setting-field">
                    <label>Product Price</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.price || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, price: e.target.value }
                      })}
                      placeholder="$29.99"
                    />
                  </div>
                  <div className="setting-field">
                    <label>Product Image URL</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.image || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, image: e.target.value }
                      })}
                      placeholder="https://example.com/product.jpg"
                    />
                  </div>
                  <div className="setting-field">
                    <label>Product Description</label>
                    <textarea 
                      rows={3}
                      value={selectedElement.content.description || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, description: e.target.value }
                      })}
                      placeholder="Product description"
                    />
                  </div>
                  <div className="setting-field">
                    <label>Button Text</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.buttonText || 'Add to Cart'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, buttonText: e.target.value }
                      })}
                    />
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'product-grid' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Products (JSON format)</label>
                    <textarea 
                      rows={8}
                      value={selectedElement.content.products ? JSON.stringify(selectedElement.content.products, null, 2) : '[]'}
                      onChange={(e) => {
                        try {
                          const products = JSON.parse(e.target.value);
                          onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                            content: { ...selectedElement.content, products }
                          });
                        } catch (e) {
                          // Invalid JSON, ignore
                        }
                      }}
                      placeholder='[{"name": "Product 1", "price": "$29.99", "image": "url", "description": "Description"}]'
                    />
                  </div>
                  <div className="setting-field">
                    <label>Columns</label>
                    <select 
                      value={selectedElement.content.columns || 3}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, columns: parseInt(e.target.value) }
                      })}
                    >
                      <option value="2">2 Columns</option>
                      <option value="3">3 Columns</option>
                      <option value="4">4 Columns</option>
                    </select>
                  </div>
                  <div className="setting-field">
                    <label>Button Text</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.buttonText || 'Add to Cart'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, buttonText: e.target.value }
                      })}
                    />
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'counter' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Starting Number</label>
                    <input 
                      type="number" 
                      value={selectedElement.content.start || 0}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, start: parseInt(e.target.value) }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Ending Number</label>
                    <input 
                      type="number" 
                      value={selectedElement.content.end || 100}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, end: parseInt(e.target.value) }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Duration (ms)</label>
                    <input 
                      type="number" 
                      value={selectedElement.content.duration || 2000}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, duration: parseInt(e.target.value) }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Title</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.title || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, title: e.target.value }
                      })}
                      placeholder="Counter title"
                    />
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'progress-bar' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Title</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.title || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, title: e.target.value }
                      })}
                      placeholder="Progress bar title"
                    />
                  </div>
                  <div className="setting-field">
                    <label>Percentage</label>
                    <input 
                      type="number" 
                      min="0"
                      max="100"
                      value={selectedElement.content.percentage || 75}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, percentage: parseInt(e.target.value) }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Bar Color</label>
                    <input 
                      type="color" 
                      value={selectedElement.content.color || '#007bff'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, color: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Background Color</label>
                    <input 
                      type="color" 
                      value={selectedElement.content.backgroundColor || '#f0f0f0'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, backgroundColor: e.target.value }
                      })}
                    />
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'testimonial' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Testimonial Text</label>
                    <textarea 
                      rows={4}
                      value={selectedElement.content.text || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, text: e.target.value }
                      })}
                      placeholder="Customer testimonial text"
                    />
                  </div>
                  <div className="setting-field">
                    <label>Author Name</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.author || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, author: e.target.value }
                      })}
                      placeholder="John Doe"
                    />
                  </div>
                  <div className="setting-field">
                    <label>Author Position</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.position || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, position: e.target.value }
                      })}
                      placeholder="CEO, Company Name"
                    />
                  </div>
                  <div className="setting-field">
                    <label>Author Image URL</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.image || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, image: e.target.value }
                      })}
                      placeholder="https://example.com/author.jpg"
                    />
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'pricing-table' && (
                <div className="settings-group">
                  <div className="setting-field">
                    <label>Plan Name</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.planName || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, planName: e.target.value }
                      })}
                      placeholder="Basic Plan"
                    />
                  </div>
                  <div className="setting-field">
                    <label>Price</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.price || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, price: e.target.value }
                      })}
                      placeholder="$29/month"
                    />
                  </div>
                  <div className="setting-field">
                    <label>Features (one per line)</label>
                    <textarea 
                      rows={6}
                      value={selectedElement.content.features ? selectedElement.content.features.join('\n') : ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, features: e.target.value.split('\n').filter(feature => feature.trim()) }
                      })}
                      placeholder="Feature 1&#10;Feature 2&#10;Feature 3"
                    />
                  </div>
                  <div className="setting-field">
                    <label>Button Text</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.buttonText || 'Get Started'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, buttonText: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>
                      <input 
                        type="checkbox" 
                        checked={selectedElement.content.featured || false}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, featured: e.target.checked }
                        })}
                      /> Featured Plan
                    </label>
                  </div>
                </div>
              )}
              {selectedElement.type === 'input-text' && (
                <div className="settings-group">
                  <h4>Input Field Settings</h4>
                  <div className="setting-field">
                    <label>Field Label</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.label || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, label: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Placeholder Text</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.placeholder || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, placeholder: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Help Text</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.helpText || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, helpText: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Default Value</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.value || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, value: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Field ID</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.fieldId || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, fieldId: e.target.value }
                      })}
                      placeholder="Unique field identifier"
                    />
                  </div>
                  <div className="setting-field">
                    <label>
                      <input 
                        type="checkbox" 
                        checked={selectedElement.content.required || false}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, required: e.target.checked }
                        })}
                      /> Required Field
                    </label>
                  </div>
                </div>
              )}
              {selectedElement.type === 'input-file' && (
                <div className="settings-group">
                  <h4>File Upload Settings</h4>
                  <div className="setting-field">
                    <label>Field Label</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.label || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, label: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Allowed File Types</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.accept || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, accept: e.target.value }
                      })}
                      placeholder="e.g., .jpg,.png,.pdf"
                    />
                  </div>
                  <div className="setting-field">
                    <label>Maximum File Size (MB)</label>
                    <input 
                      type="number" 
                      value={selectedElement.content.maxSize || 5}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, maxSize: parseInt(e.target.value) }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>
                      <input 
                        type="checkbox" 
                        checked={selectedElement.content.multiple || false}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, multiple: e.target.checked }
                        })}
                      /> Allow Multiple Files
                    </label>
                  </div>
                  <div className="setting-field">
                    <label>Field ID</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.fieldId || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, fieldId: e.target.value }
                      })}
                      placeholder="Unique field identifier"
                    />
                  </div>
                  <div className="setting-field">
                    <label>
                      <input 
                        type="checkbox" 
                        checked={selectedElement.content.required || false}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, required: e.target.checked }
                        })}
                      /> Required Field
                    </label>
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'toggle' && (
                <div className="settings-group">
                  <h4>Toggle Switch Settings</h4>
                  <div className="setting-field">
                    <label>Field Label</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.label || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, label: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>On Text</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.onText || 'On'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, onText: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Off Text</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.offText || 'Off'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, offText: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>
                      <input 
                        type="checkbox" 
                        checked={selectedElement.content.defaultChecked || false}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, defaultChecked: e.target.checked }
                        })}
                      /> Default Checked
                    </label>
                  </div>
                  <div className="setting-field">
                    <label>Field ID</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.fieldId || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, fieldId: e.target.value }
                      })}
                      placeholder="Unique field identifier"
                    />
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'range' && (
                <div className="settings-group">
                  <h4>Range Slider Settings</h4>
                  <div className="setting-field">
                    <label>Field Label</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.label || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, label: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Minimum Value</label>
                    <input 
                      type="number" 
                      value={selectedElement.content.min || 0}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, min: parseInt(e.target.value) }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Maximum Value</label>
                    <input 
                      type="number" 
                      value={selectedElement.content.max || 100}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, max: parseInt(e.target.value) }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Default Value</label>
                    <input 
                      type="number" 
                      value={selectedElement.content.value || 50}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, value: parseInt(e.target.value) }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Step</label>
                    <input 
                      type="number" 
                      value={selectedElement.content.step || 1}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, step: parseInt(e.target.value) }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Field ID</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.fieldId || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, fieldId: e.target.value }
                      })}
                      placeholder="Unique field identifier"
                    />
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'color-picker' && (
                <div className="settings-group">
                  <h4>Color Picker Settings</h4>
                  <div className="setting-field">
                    <label>Field Label</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.label || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, label: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Default Color</label>
                    <input 
                      type="color" 
                      value={selectedElement.content.value || '#000000'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, value: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Field ID</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.fieldId || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, fieldId: e.target.value }
                      })}
                      placeholder="Unique field identifier"
                    />
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'textarea' && (
                <div className="settings-group">
                  <h4>Textarea Settings</h4>
                  <div className="setting-field">
                    <label>Field Label</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.label || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, label: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Placeholder Text</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.placeholder || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, placeholder: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Help Text</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.helpText || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, helpText: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Number of Rows</label>
                    <input 
                      type="number" 
                      min="1"
                      max="20"
                      value={selectedElement.content.rows || 4}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, rows: parseInt(e.target.value) }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Field ID</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.fieldId || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, fieldId: e.target.value }
                      })}
                      placeholder="Unique field identifier"
                    />
                  </div>
                  <div className="setting-field">
                    <label>
                      <input 
                        type="checkbox" 
                        checked={selectedElement.content.required || false}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, required: e.target.checked }
                        })}
                      /> Required Field
                    </label>
                  </div>
                </div>
              )}
              
              {selectedElement.type === 'select' && (
                <div className="settings-group">
                  <h4>Select Field Settings</h4>
                  <div className="setting-field">
                    <label>Field Label</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.label || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, label: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Options (one per line)</label>
                    <textarea 
                      rows={6}
                      value={selectedElement.content.options ? selectedElement.content.options.join('\n') : ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, options: e.target.value.split('\n').filter(opt => opt.trim()) }
                      })}
                      placeholder="Option 1&#10;Option 2&#10;Option 3"
                    />
                  </div>
                  <div className="setting-field">
                    <label>Help Text</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.helpText || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, helpText: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Field ID</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.fieldId || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, fieldId: e.target.value }
                      })}
                      placeholder="Unique field identifier"
                    />
                  </div>
                  <div className="setting-field">
                    <label>
                      <input 
                        type="checkbox" 
                        checked={selectedElement.content.required || false}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, required: e.target.checked }
                        })}
                      /> Required Field
                    </label>
                  </div>
                </div>
              )}
              
              {(selectedElement.type === 'checkbox' || selectedElement.type === 'radio') && (
                <div className="settings-group">
                  <h4>{selectedElement.type === 'checkbox' ? 'Checkbox' : 'Radio'} Settings</h4>
                  <div className="setting-field">
                    <label>Field Label</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.label || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, label: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Options (one per line)</label>
                    <textarea 
                      rows={6}
                      value={selectedElement.content.options ? selectedElement.content.options.map(opt => opt.label || opt).join('\n') : ''}
                      onChange={(e) => {
                        const options = e.target.value.split('\n').filter(opt => opt.trim()).map(opt => ({ 
                          label: opt, 
                          value: opt.toLowerCase().replace(/\s+/g, '_'),
                          checked: false 
                        }));
                        onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, options }
                        });
                      }}
                      placeholder="Option 1&#10;Option 2&#10;Option 3"
                    />
                  </div>
                  <div className="setting-field">
                    <label>Help Text</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.helpText || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, helpText: e.target.value }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Field ID</label>
                    <input 
                      type="text" 
                      value={selectedElement.content.fieldId || ''}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, fieldId: e.target.value }
                      })}
                      placeholder="Unique field identifier"
                    />
                  </div>
                  {selectedElement.type === 'radio' && (
                    <div className="setting-field">
                      <label>Field Name</label>
                      <input 
                        type="text" 
                        value={selectedElement.content.name || ''}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, name: e.target.value }
                        })}
                        placeholder="radio-group"
                      />
                    </div>
                  )}
                  <div className="setting-field">
                    <label>
                      <input 
                        type="checkbox" 
                        checked={selectedElement.content.required || false}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          content: { ...selectedElement.content, required: e.target.checked }
                        })}
                      /> Required Field
                    </label>
                  </div>
                </div>
              )}
            </>
          )}
          
          {activeTab === 'style' && (
            <>
              <div className="settings-group">
                <h4>Typography</h4>
                <div className="setting-field">
                  <label>Text Color</label>
                  <input 
                    type="color" 
                    value={selectedElement.styles?.color || '#000000'}
                    onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                      styles: { ...selectedElement.styles, color: e.target.value }
                    })}
                  />
                </div>
                <div className="setting-field">
                  <label>Font Size (px)</label>
                  <input 
                    type="number" 
                    value={selectedElement.styles?.fontSize || 16}
                    onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                      styles: { ...selectedElement.styles, fontSize: parseInt(e.target.value) || 16 }
                    })}
                  />
                </div>
                <div className="setting-field">
                  <label>Font Weight</label>
                  <select 
                    value={selectedElement.styles?.fontWeight || 'normal'}
                    onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                      styles: { ...selectedElement.styles, fontWeight: e.target.value }
                    })}
                  >
                    <option value="normal">Normal</option>
                    <option value="500">Medium</option>
                    <option value="600">Semibold</option>
                    <option value="700">Bold</option>
                    <option value="800">Extra Bold</option>
                  </select>
                </div>
                <div className="setting-field">
                  <label>Text Alignment</label>
                  <select 
                    value={selectedElement.styles?.textAlign || 'left'}
                    onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                      styles: { ...selectedElement.styles, textAlign: e.target.value }
                    })}
                  >
                    <option value="left">Left</option>
                    <option value="center">Center</option>
                    <option value="right">Right</option>
                  </select>
                </div>
                <div className="setting-field">
                  <label>Line Height</label>
                  <input 
                    type="number" 
                    step="0.1"
                    value={selectedElement.styles?.lineHeight || 1.2}
                    onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                      styles: { ...selectedElement.styles, lineHeight: parseFloat(e.target.value) || 1.2 }
                    })}
                  />
                </div>
              </div>

              {['input-text','input-email','input-password','input-number','textarea','select','checkbox','radio'].includes(selectedElement.type) && (
                <div className="settings-group">
                  <h4>Label Styling</h4>
                  <div className="setting-field">
                    <label>Label Color</label>
                    <input 
                      type="color" 
                      value={selectedElement.content.labelStyle?.color || '#000000'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, labelStyle: { ...selectedElement.content.labelStyle, color: e.target.value } }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Label Font Size (px)</label>
                    <input 
                      type="number" 
                      value={selectedElement.content.labelStyle?.fontSize || 14}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, labelStyle: { ...selectedElement.content.labelStyle, fontSize: parseInt(e.target.value) || 14 } }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Label Font Weight</label>
                    <select 
                      value={selectedElement.content.labelStyle?.fontWeight || 'bold'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, labelStyle: { ...selectedElement.content.labelStyle, fontWeight: e.target.value } }
                      })}
                    >
                      <option value="normal">Normal</option>
                      <option value="500">Medium</option>
                      <option value="600">Semibold</option>
                      <option value="bold">Bold</option>
                    </select>
                  </div>
                  <div className="setting-field">
                    <label>Label Margin Bottom (px)</label>
                    <input 
                      type="number" 
                      value={selectedElement.content.labelStyle?.marginBottom || 5}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, labelStyle: { ...selectedElement.content.labelStyle, marginBottom: parseInt(e.target.value) || 0 } }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Label Alignment</label>
                    <select 
                      value={selectedElement.content.labelStyle?.textAlign || 'left'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, labelStyle: { ...selectedElement.content.labelStyle, textAlign: e.target.value } }
                      })}
                    >
                      <option value="left">Left</option>
                      <option value="center">Center</option>
                      <option value="right">Right</option>
                    </select>
                  </div>
                </div>
              )}

              {['input-text','input-email','input-password','input-number','textarea','select'].includes(selectedElement.type) && (
                <div className="settings-group">
                  <h4>Field Styling</h4>
                  <div className="setting-field">
                    <label>Field Background</label>
                    <input 
                      type="color" 
                      value={selectedElement.content.fieldStyle?.backgroundColor || '#f9f9f9'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, fieldStyle: { ...selectedElement.content.fieldStyle, backgroundColor: e.target.value } }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Border Color</label>
                    <input 
                      type="color" 
                      value={selectedElement.content.fieldStyle?.borderColor || '#dddddd'}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, fieldStyle: { ...selectedElement.content.fieldStyle, borderColor: e.target.value } }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Border Radius (px)</label>
                    <input 
                      type="number" 
                      value={selectedElement.content.fieldStyle?.borderRadius || 4}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, fieldStyle: { ...selectedElement.content.fieldStyle, borderRadius: parseInt(e.target.value) || 0 } }
                      })}
                    />
                  </div>
                  <div className="setting-field">
                    <label>Field Padding (px)</label>
                    <input 
                      type="number" 
                      value={selectedElement.content.fieldStyle?.padding || 8}
                      onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                        content: { ...selectedElement.content, fieldStyle: { ...selectedElement.content.fieldStyle, padding: parseInt(e.target.value) || 8 } }
                      })}
                    />
                  </div>
                </div>
              )}

              <div className="settings-group">
                <h4>Spacing</h4>
                <div className="setting-field">
                  <label>Margin (px)</label>
                  <div className="spacing-controls">
                    <div className="spacing-field">
                      <label>Top</label>
                      <input 
                        type="number" 
                        value={selectedElement.styles?.margin?.top || 0}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          styles: {
                            ...selectedElement.styles,
                            margin: { ...selectedElement.styles?.margin, top: parseInt(e.target.value) || 0 }
                          }
                        })}
                      />
                    </div>
                    <div className="spacing-field">
                      <label>Right</label>
                      <input 
                        type="number" 
                        value={selectedElement.styles?.margin?.right || 0}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          styles: {
                            ...selectedElement.styles,
                            margin: { ...selectedElement.styles?.margin, right: parseInt(e.target.value) || 0 }
                          }
                        })}
                      />
                    </div>
                    <div className="spacing-field">
                      <label>Bottom</label>
                      <input 
                        type="number" 
                        value={selectedElement.styles?.margin?.bottom || 0}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          styles: {
                            ...selectedElement.styles,
                            margin: { ...selectedElement.styles?.margin, bottom: parseInt(e.target.value) || 0 }
                          }
                        })}
                      />
                    </div>
                    <div className="spacing-field">
                      <label>Left</label>
                      <input 
                        type="number" 
                        value={selectedElement.styles?.margin?.left || 0}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          styles: {
                            ...selectedElement.styles,
                            margin: { ...selectedElement.styles?.margin, left: parseInt(e.target.value) || 0 }
                          }
                        })}
                      />
                    </div>
                  </div>
                </div>
                <div className="setting-field">
                  <label>Padding (px)</label>
                  <div className="spacing-controls">
                    <div className="spacing-field">
                      <label>Top</label>
                      <input 
                        type="number" 
                        value={selectedElement.styles?.padding?.top || 0}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          styles: {
                            ...selectedElement.styles,
                            padding: { ...selectedElement.styles?.padding, top: parseInt(e.target.value) || 0 }
                          }
                        })}
                      />
                    </div>
                    <div className="spacing-field">
                      <label>Right</label>
                      <input 
                        type="number" 
                        value={selectedElement.styles?.padding?.right || 0}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          styles: {
                            ...selectedElement.styles,
                            padding: { ...selectedElement.styles?.padding, right: parseInt(e.target.value) || 0 }
                          }
                        })}
                      />
                    </div>
                    <div className="spacing-field">
                      <label>Bottom</label>
                      <input 
                        type="number" 
                        value={selectedElement.styles?.padding?.bottom || 0}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          styles: {
                            ...selectedElement.styles,
                            padding: { ...selectedElement.styles?.padding, bottom: parseInt(e.target.value) || 0 }
                          }
                        })}
                      />
                    </div>
                    <div className="spacing-field">
                      <label>Left</label>
                      <input 
                        type="number" 
                        value={selectedElement.styles?.padding?.left || 0}
                        onChange={(e) => onUpdateWidget(selectedElement.sectionId, selectedElement.columnId, selectedElement.id, {
                          styles: {
                            ...selectedElement.styles,
                            padding: { ...selectedElement.styles?.padding, left: parseInt(e.target.value) || 0 }
                          }
                        })}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };
  
  const renderPageSettings = () => {
    return (
      <div className="settings-panel border-start bg-light">
        <div className="settings-header">
          <h3>Page Settings</h3>
          <button className="close-btn" onClick={() => setShowSettings(false)}>×</button>
        </div>
        
        <div className="settings-content">
          <div className="settings-group">
            <div className="setting-field">
              <label>Page Title</label>
              <input 
                type="text" 
                value={pageSettings.pageTitle || ''}
                onChange={(e) => setPageSettings({ ...pageSettings, pageTitle: e.target.value })}
              />
            </div>
            
            <div className="setting-field">
              <label>Page Layout</label>
              <select 
                value={pageSettings.pageLayout || 'full-width'}
                onChange={(e) => setPageSettings({ ...pageSettings, pageLayout: e.target.value })}
              >
                <option value="full-width">Full Width</option>
                <option value="boxed">Boxed</option>
              </select>
            </div>
            
            <div className="setting-field">
              <label>Page Background Color</label>
              <input 
                type="color" 
                value={pageSettings.pageBackground || '#ffffff'}
                onChange={(e) => setPageSettings({ ...pageSettings, pageBackground: e.target.value })}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  const getWidgetName = (type) => {
    const names = {
      heading: 'Heading',
      paragraph: 'Paragraph',
      button: 'Button',
      image: 'Image',
      video: 'Video',
      audio: 'Audio',
      gallery: 'Gallery',
      carousel: 'Carousel',
      icon: 'Icon',
      divider: 'Divider',
      spacer: 'Spacer',
      container: 'Container',
      grid: 'Grid',
      tabs: 'Tabs',
      accordion: 'Accordion',
      counter: 'Counter',
      'progress-bar': 'Progress Bar',
      testimonial: 'Testimonial',
      'pricing-table': 'Pricing Table',
      'input-text': 'Text Input',
      'input-email': 'Email Input',
      'input-password': 'Password Input',
      'input-number': 'Number Input',
      'input-date': 'Date Picker',
      'input-time': 'Time Picker',
      'input-file': 'File Upload',
      textarea: 'Textarea',
      select: 'Dropdown',
      checkbox: 'Checkbox',
      radio: 'Radio Button',
      toggle: 'Toggle Switch',
      range: 'Range Slider',
      'color-picker': 'Color Picker',
      modal: 'Modal',
      tooltip: 'Tooltip',
      alert: 'Alert',
      badge: 'Badge',
      code: 'Code Block',
      embed: 'Embed',
      product: 'Product',
      'product-grid': 'Product Grid'
    };
    return names[type] || 'Widget';
  };
  
  if (selectedElement) return renderWidgetSettings();
  if (selectedSection) return renderSectionSettings();
  return renderPageSettings();
};

export default ElementorSettings;